export default function(title) {
  window.document.title = title || ''
}
